import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['address', 'streetAddress', 'city', 'postalCode', 'country'];

  #autocomplete = null;
  #placeChangedListener = null;
  #onWindowLoad = null;

  connect() {
    if (typeof google === 'undefined') {
      this.#onWindowLoad = () => this.#initializeAutocomplete();
      window.addEventListener('load', this.#onWindowLoad);
    } else {
      this.#initializeAutocomplete();
    }
  }

  disconnect() {
    if (this.#onWindowLoad) {
      window.removeEventListener('load', this.#onWindowLoad);
    }

    if (this.#placeChangedListener) {
      google.maps.event.removeListener(this.#placeChangedListener);
    }
  }

  #initializeAutocomplete() {
    if (!this.hasAddressTarget) return;

    const options = {
      fields: ['address_components'],
      types: ['address'],
    };

    this.#autocomplete = new google.maps.places.Autocomplete(this.addressTarget, options);
    this.#placeChangedListener = this.#autocomplete.addListener('place_changed', () => this.#fillAddress());
  }

  #fillAddress() {
    const place = this.#autocomplete.getPlace();
    let streetNumber = '';
    let route = '';

    place.address_components.forEach((component) => {
      if (component.types.includes('street_number')) {
        streetNumber = component.short_name;
      } else if (component.types.includes('route')) {
        route = component.short_name;
      } else if (component.types.includes('locality')) {
        if (this.hasCityTarget) this.cityTarget.value = component.short_name;
      } else if (component.types.includes('postal_code')) {
        if (this.hasPostalCodeTarget) this.postalCodeTarget.value = component.short_name;
      } else if (component.types.includes('country')) {
        this.#setCountry(component.short_name);
      }
    });

    const fullAddress = [streetNumber, route].filter(Boolean).join(' ');
    if (this.hasStreetAddressTarget && fullAddress) {
      this.streetAddressTarget.value = fullAddress;
    }
  }

  #setCountry(countryCode) {
    if (!this.hasCountryTarget) return;

    const select = this.countryTarget;
    if (countryCode && select.tomselect) {
      select.tomselect.setValue(countryCode);
    }
  }
}
